import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/utils'

const CardVariants = cva(
  cn('p-4 bg-muted/40 border border-muted rounded-lg shadow'),
  {
    variants: {},
    defaultVariants: {},
  },
)

interface CardProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof CardVariants> {
  asChild?: boolean
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'div'
    return (
      <Comp className={cn(CardVariants({ className }))} ref={ref} {...props} />
    )
  },
)
Card.displayName = 'Card'

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      className={cn('mb-2 flex items-center justify-between', className)}
      ref={ref}
      {...props}
    />
  )
})
CardHeader.displayName = 'CardHeader'

const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => {
  return (
    <h3 className={cn('text-sm font-bold', className)} ref={ref} {...props} />
  )
})
CardTitle.displayName = 'CardTitle'

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      className={cn(
        'mt-4 flex items-center justify-between gap-2 border-t border-muted pt-3',
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})
CardFooter.displayName = 'CardFooter'

export { Card, CardFooter, CardHeader, CardTitle }
